import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { Loan } from 'src/model/loan.model';
import { Profile } from 'src/model/profile.model';
import { ProfileService } from 'src/services/profile.service';

@Component({
    selector: 'app-move-loan',
    templateUrl: './move-loan.component.html',
    styleUrls: ['./move-loan.component.scss'],
    standalone: false
})
export class MoveLoanComponent {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private router = inject(Router);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private profileService = inject(ProfileService);

  disabledSubmit = false;
  @Input() profileList: Profile[] = [];

  @Input() selectedCustomer: Customer;
  searchProfileList: Profile[] = [];

  searchName: string;
  searchICNum: string;
  searchCustCode: string;

  selectedProfile: Profile;
  selectedLoan: Loan;

  async findCustomer(name: string, ic: string, customerCode: string) {
    this.disabledSubmit = true;
    this.searchProfileList.splice(0, this.searchProfileList.length);
    if (ic != undefined) ic = this.sharedService.sanitizeICNumInput(ic);
    try {
      this.searchProfileList = await this.profileService.getCompanyProfileSearch(this.selectedCustomer.CompanyId, name, ic, customerCode);
      if (this.searchProfileList.length == 0) {
        this.sharedService.openAlert("Do not have any other customer with these search criteria", ALERT_TYPE.DANGER);
      }
    } finally {
      this.disabledSubmit = false;
    }
  }

  confirmBeforeMoveToSameCustomer(profile: Profile) {
    this.disabledSubmit = true;

    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to move profile " +
      this.selectedLoan.ID + "-" + this.selectedLoan.LoanCode + "(RM " + this.selectedLoan.Principal + ")" + " to " + profile.ID + "-" + this.selectedCustomer.Name + "(" + profile.CustomerCode + ")";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.moveLoan(this.selectedLoan.ID, profile.ID, profile.CustomerID, false);
      else
        this.disabledSubmit = false;
    });

    return proceed;
  }

  confirmBeforeMove(customer: Profile, isForceMove: boolean) {
    this.disabledSubmit = true;

    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to move loan " +
      this.selectedLoan.ID + "-" + this.selectedLoan.LoanCode + "(RM " + this.selectedLoan.Principal + ")" + " to " + customer.CustomerID + "-" + customer.CustomerName + "(" + customer.ICNumber + ")";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.moveLoan(this.selectedLoan.ID, customer.ID, customer.CustomerID, isForceMove);
      else
        this.disabledSubmit = false;
    });

    return proceed;
  }

  moveLoan(loanId: number, targetProfileId: number, customerId: number, isForceMove: boolean) {
    const data = {
      "targetProfileId": targetProfileId
    };

    let xhr;
    if (isForceMove == true)
      xhr = this.restApi.putRequest(this.constructApi.getForceMoveLoan(loanId), data);
    else
      xhr = this.restApi.putRequest(this.constructApi.getMoveLoan(loanId), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          // var urls = window.location.pathname.split("/")
          // this.location.replaceState(urls[1] + "/" + customerId);

          // window.location.reload();
          this.reset();
          this.router.navigate(['/manageCustomer', customerId, targetProfileId]);
        } else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  setActive(action: string) {
    if (action == "Merge") {
      if (this.profileList.length > 1) return "active";
    }
    else
      if (this.profileList.length == 1) return "active";
  }

  detectEnableSearch() {
    if (this.searchICNum == "" && this.searchName == "" && this.searchCustCode == "")
      this.disabledSubmit = true;
    else
      this.disabledSubmit = false;

    return this.disabledSubmit;
  }

  reset() {
    this.activeModal.close();
  }
}
